import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from '../util/withRouter';

export default function (ComposedComponent) {
  class RequireSubscription extends Component {
    static contextTypes = {
      router: PropTypes.object,
    };

    redirect(to) {
      global.window && window.location && window.location.replace(to + window.location.search);
    }

    render() {
      if (this.props.isLoading) {
        return <div></div>;
      }

      if (this.props.user.isJiraLicense && this.props.user.cancelled) {
        this.redirect('/cancelled');
        return null;
      }

      if (this.props.user.trialExpired && this.props.user.isCustomPlan) {
        this.redirect('/expired');
        return null;
      }

      if (
        this.props.user.permissions &&
        !this.props.user.permissions.manageBilling &&
        (this.props.user.trialExpired || this.props.user.cancelled)
      ) {
        if (this.props.user.trialExpired) {
          this.redirect('/expired');
        } else if (this.props.user.cancelled) {
          this.redirect('/cancelled');
        }

        return null;
      }

      if (this.props.user.trialExpired) {
        this.redirect('/subscribe');
        return null;
      }

      if (this.props.user.cancelled) {
        this.redirect('/billing');
        return null;
      }

      return <ComposedComponent {...this.props} />;
    }
  }

  function mapStateToProps(state) {
    return {
      isLoading: state.auth.isLoading,
      user: state.auth.user,
    };
  }

  return withRouter(connect(mapStateToProps)(RequireSubscription));
}
